import React from 'react';

const ClientLogos = ({ currentTheme }) => {
  const clientsByCategory = {
    events: [
      { name: 'The Knot', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Wedding Platform' },
      { name: 'WeddingWire', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Event Planning' },
      { name: 'Zola', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Wedding Registry' },
      { name: 'Kleinfeld Bridal', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Bridal Fashion' },
      { name: 'David\'s Bridal', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Wedding Attire' },
      { name: 'Martha Stewart Weddings', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Wedding Media' }
    ],
    realestate: [
      { name: 'Coldwell Banker', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Real Estate' },
      { name: 'RE/MAX', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Property Sales' },
      { name: 'Sotheby\'s International', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Luxury Real Estate' },
      { name: 'Zillow', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Property Platform' },
      { name: 'Compass', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Real Estate Tech' },
      { name: 'Douglas Elliman', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Property Management' }
    ],
    marketing: [
      { name: 'Nike', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Athletic Wear' },
      { name: 'Apple', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Technology' },
      { name: 'Coca-Cola', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Beverages' },
      { name: 'Tesla', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Electric Vehicles' },
      { name: 'Airbnb', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Travel Platform' },
      { name: 'Spotify', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Music Streaming' }
    ],
    design: [
      { name: 'MIT Media Lab', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Research Institute' },
      { name: 'IDEO', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Design Consultancy' },
      { name: 'Frog Design', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Innovation Studio' },
      { name: 'Pentagram', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Design Agency' },
      { name: 'Ammunition Group', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Product Design' },
      { name: 'Fuseproject', logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop', industry: 'Creative Studio' }
    ]
  };

  const allClients = [
    ...clientsByCategory?.events?.slice(0, 2),
    ...clientsByCategory?.realestate?.slice(0, 2),
    ...clientsByCategory?.marketing?.slice(0, 2),
    ...clientsByCategory?.design?.slice(0, 2)
  ];

  const currentClients = currentTheme && currentTheme !== 'default' 
    ? clientsByCategory?.[currentTheme] || allClients
    : allClients;

  const getThemeStyles = () => {
    const styles = {
      events: 'from-rose-50 to-amber-50 border-rose-200',
      realestate: 'from-blue-50 to-cyan-50 border-blue-200',
      marketing: 'from-orange-50 to-red-50 border-orange-200',
      design: 'from-purple-50 to-pink-50 border-purple-200',
      default: 'from-muted/30 to-background border-border'
    };
    return styles?.[currentTheme] || styles?.default;
  };

  return (
    <section className={`py-16 bg-gradient-to-r ${getThemeStyles()} border-y transition-all duration-1000`}>
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-fluid-2xl font-display font-bold text-foreground mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            We've had the privilege of creating visual stories for some of the most recognizable brands 
            across diverse industries.
          </p>
        </div>

        {/* Client Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {currentClients?.map((client, index) => (
            <div
              key={`${client?.name}-${index}`}
              className="group relative"
            >
              <div className="bg-white rounded-xl p-6 shadow-sm border border-border/50 hover:shadow-md transition-all duration-300 hover:-translate-y-1">
                <div className="aspect-[3/2] flex items-center justify-center">
                  <img
                    src={client?.logo}
                    alt={`${client?.name} logo`}
                    className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300 opacity-70 group-hover:opacity-100"
                  />
                </div>
                
                {/* Tooltip */}
                <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-foreground text-background text-xs font-medium px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none whitespace-nowrap z-10">
                  {client?.name}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-foreground"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-fluid-2xl font-bold text-accent mb-2">500+</div>
            <div className="text-muted-foreground text-sm font-medium">Projects Completed</div>
          </div>
          <div className="text-center">
            <div className="text-fluid-2xl font-bold text-accent mb-2">150+</div>
            <div className="text-muted-foreground text-sm font-medium">Happy Clients</div>
          </div>
          <div className="text-center">
            <div className="text-fluid-2xl font-bold text-accent mb-2">25+</div>
            <div className="text-muted-foreground text-sm font-medium">Industry Awards</div>
          </div>
          <div className="text-center">
            <div className="text-fluid-2xl font-bold text-accent mb-2">8+</div>
            <div className="text-muted-foreground text-sm font-medium">Years Experience</div>
          </div>
        </div>

        {/* Bottom Text */}
        <div className="text-center mt-12">
          <p className="text-muted-foreground text-sm">
            Join the growing list of brands who trust Skycrest Studios with their visual storytelling needs.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;